import React from 'react';
import InterfaceLink from 'app/components/links/InterfaceLink';
import snmpMetadata from '@kentik/ui-shared/dictionary/snmpMetadata';
import $devices from 'app/stores/device/$devices';
import { observer } from 'mobx-react';

const InterfaceDisplayValue = ({ model, property }) => {
  const mapping = snmpMetadata[property];
  const { interfaceKvs } = model.attributes;
  const value = interfaceKvs[property];

  if (mapping) {
    return `${mapping[value]} (${value})`;
  }

  if (property === 'isAbove' || property === 'isBelow') {
    const device = $devices.deviceSummariesById[model.get('device_id')];

    if (!device) {
      return value.split(',').join(', ');
    }

    return (
      <>
        {value.split(',').map((snmpId) => (
          <InterfaceLink key={snmpId} snmp_id={snmpId} device_name={device.device_name} mr="4px">
            {snmpId}
          </InterfaceLink>
        ))}
      </>
    );
  }

  return value;
};

export default observer(InterfaceDisplayValue);
